import Vue from 'vue'
import Router from 'vue-router'
import Person from '@/views/Person'
import Login from '@/views/Login'
import Main from '@/views/Main'
import Detail from '@/views/Detail'
import History from '@/views/History'
import Likes from '@/views/Likes'
import Recovery from '@/views/Recovery'
import DocDetail from '@/views/DocDetail'
import DocShare from '@/views/DocShare'
import Index from '@/views/Index'
import Home from '@/views/Home'
import About from '@/views/About'
import Down from '@/views/Down'
import Invite from '@/views/Invite'
import BeMember from '@/views/BeMember'
import UpdateLog from '@/views/UpdateLog'
import Help from '@/views/Help'
import Agreement from '@/views/Agreement'
import Secret from '@/views/Secret'
import Collect from '@/views/Collect'
import DocDetailMobile from '@/views/mobile/DocDetail'
import Contact from '@/views/Contact'

Vue.use(Router)

Vue.directive('title', {//单个修改标题
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/main',
      name: 'main',
      component: Main,
      children:[
        {
          name: 'person',
          path: '/person',
          component: Person
         },
        {
          name: 'detail',
          path: '/detail',
          component: Detail
         },
         {
          name: 'history',
          path: '/history',
          component: History
         },
         {
          name: 'likes',
          path: '/likes',
          component: Likes
         },
         {
          name: 'collect',
          path: '/collect',
          component: Collect
         },
         {
          name: 'recovery',
          path: '/recovery',
          component: Recovery
         }
      ]
    },
    {
      name: 'login',
      path: '/login',
      component: Login
    },
    {
      name: 'agreement',
      path: '/agreement',
      component: Agreement
    },
    {
      name: 'secret',
      path: '/secret',
      component: Secret
    },
    {
      name: 'docDetail',
      path: '/doc',
      component: DocDetail
    },
    {
      name: 'docDetailMobile',
      path: '/mdoc',
      component: DocDetailMobile
    },
    {
      name: 'docShare',
      path: '/d/:id',
      component: DocShare
    },
    {
      name: 'index',
      path: '/',
      component: Index,
      children:[
        {
          name: 'home',
          path: '',
          component: Home
        },
        {
          name: 'about',
          path: '/about',
          component: About
        },
        {
          name: 'down',
          path: '/down',
          component: Down
        },
        {
          name: 'invite',
          path: '/invite',
          component: Invite
        },
        {
          name: 'beMember',
          path: '/beMember',
          component: BeMember
        },
        {
          name: 'updateLog',
          path: '/updateLog',
          component: UpdateLog
        },
        {
          name: 'contact',
          path: '/contact',
          component: Contact
         },
        {
          name: 'help',
          path: '/help',
          component: Help
        },
      ]
    },
  ]
})


router.beforeEach(async (to, from, next) => {

  const token = sessionStorage.getItem("token")
  if (to.path === '/login' ) {
    sessionStorage.setItem("token",null);
    next()
    return false
  }

  if (!token || token == 'null') {
    if (to.path === '/person' ) {
      next({ path: '/login' })
      return false
    }
  }
  next()
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js